import React, { useState, useEffect } from "react";
import {
  Row,
  Card,
  CardBody,
  Input,
  FormGroup,
  Label,
  Button,
  Form,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  CardHeader,
} from "reactstrap";
import { Link, useParams } from "react-router-dom";
import {
  Colxx,
  Separator,
} from "../../../../../src/components/common/CustomBootstrap";
import { toast } from "react-toastify";
import { JobService } from "../../../../services/JobService";
import { getEnumLists } from "../../../../services/MetadataService";
import { MdOutlineArrowBackIosNew } from "react-icons/md";
import { isNullOrEmpty } from "../../../../config/ENV";
toast.configure();

const FileUpload = (props) => {
  var { id } = useParams();
  const [files, setFiles] = useState([]);
  const [jobLinks, setJobLinks] = useState([]);
  const [inputField, setInputField] = useState({
    name: "",
    description: "",
    documentName: "",
    documentDescription: "",
    email: "",
    primaryPhone: "",
    secondaryNumber: "",
    additionalPublicInfoDesc: "",
    internalNoteDesc: "",
    zipCode: "",

    position: "",
  });

  const [inputFieldLink, setInputFieldLink] = useState({
    name: "",
    link: "",
    description: "",
  });

  const inputsHandlerLink = (e) => {
    const { name, value } = e.target;
    setInputFieldLink((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const [fileType, setFileType] = useState("");
  const [modalRight, setModalRight] = useState(false);
  const [modalLink, setModalLink] = useState(false);
  const [fileTypes, setFileTypes] = useState([]);
  const [fileupload, setfileupload] = useState();
  const [fileuploadname, setfileuploadname] = useState();
  const [jobStatus, setJobStatus] = useState("");
  const [selectedJobLinkId, setSelectedJobLinkId] = useState("");
  const [selectedJobLinkName, setSelectedJobLinkName] = useState("");
  const [isUpdate, setIsUpdate] = useState(false);

  const inputsHandler = (e) => {
    const { name, value } = e.target;
    setInputField((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
    }
  };

  const handleFileTypeSelectChange = (e) => {
    setFileType(e.target.value);
  };

  const getDocuments = () => {
    JobService.getFiles(id).then((response) => {
      try {
        if (response.status === 200) {
          var DocumentDetails = response.data.files;
          setFiles(DocumentDetails);
        }
      } catch (err) {}
    });
  };

  let count = 0;
  useEffect(() => {
    getJobEnums();
    if (id != 0) {
      getJobDetails();
      getDocuments();
      getJobLinksList();
    }
  }, [count]);
  const getJobDetails = () => {
    try {
      var jobDetails = props.jobDetails;
      if (jobDetails != null) {
        if (jobDetails.jobStatus !== null || jobDetails.jobStatus !== "") {
          setJobStatus(jobDetails.jobStatus.key);
        }
      }
    } catch (err) {
      console.log("message" + JSON.stringify(err.message));
    }
  };
  const getJobEnums = () => {
    getEnumLists().then((response) => {
      try {
        if (response !== null) {
          let fileTypes = response.fileTypes;
          if (fileTypes != null) {
            setFileTypes(fileTypes);
          }
        }
      } catch (err) {}
    });
  };

  const uploadFile = () => {
    if (id === "") {
      toast.error("Please fill basic info");
      return;
    }

    let file = document.getElementById("JobFiles").files[0];

    if (inputField.name === "") {
      toast.error("Please enter name");
      return;
    }
    if (fileType === "") {
      toast.error("Please select file type");
      return;
    }
    if (file === undefined) {
      toast.error("Please select file to upload");
      return;
    }

    let fd = new FormData();
    fd.append("file", file);
    fd.append("fileName", inputField.name);
    fd.append("fileType", fileType);
    fd.append("description", inputField.description);

    JobService.uploadFile(fd).then((response) => {
      try {
        toast.success("File uploaded  successfully");
        setModalRight(false);
        getDocuments();

        // history.goBack();
      } catch (err) {
        toast.success("job error" + err);
      }
    });
  };

  const handlefileupload = (deleteId, name) => {
    setfileupload(deleteId);
    setfileuploadname(name);
  };

  const deleteDocument = () => {
    JobService.removeFiles(fileupload).then((response) => {
      try {
        if (response.message != null) {
          if (response.data.error_message !== "") {
          }
        } else {
          if (response.data != null) {
            toast.success("File deleted successfully");
            getDocuments();
          }
        }
      } catch (err) {}
    });
  };

  const onAddSoftSkills = () => {
    setModalRight(true);

    setFileType("");
    setInputField((prevState) => ({
      ...prevState,
      name: "",
      description: "",
    }));
  };

  const AddLinks = () => {
    setSelectedJobLinkId("");
    setModalLink(true);
    setInputFieldLink((prevState) => ({
      ...prevState,
      name: "",
      link: "",
      description: "",
    }));
  };

  const handleNextButton = () => {
    props.parentCallback("skills");
  };

  const handlePreviousButton = () => {
    props.parentCallback("basicInfo");
  };

  const getJobLinksList = () => {
    if (!isNullOrEmpty(id)) {
      JobService.getJobLinks(id).then((response) => {
        try {
          if (response.status === 200) {
            if (response.data !== null) {
              if (response.data.jobLinks.length > 0) {
                setJobLinks(response.data.jobLinks);
              } else {
                setJobLinks([]);
              }
            }
          }
        } catch (err) {
          console.error("getJobLinks " + JSON.stringify(err));
        }
      });
    }
  };

  const addJobLink = () => {
    if (id === "") {
      toast.error("Please fill basic info");
      return;
    }

    const name = inputFieldLink.name;
    const link = inputFieldLink.link;
    const description = inputFieldLink.description;

    if (isNullOrEmpty(name)) {
      toast.error("Please enter name");
      return;
    }

    if (isNullOrEmpty(link)) {
      toast.error("Please enter link");
      return;
    }

    const jobLinkObj = {
      name: name,
      link: link,
      description: description,
    };

    if (id != 0) {
      if (selectedJobLinkId !== "") {
        JobService.updateJobLink(jobLinkObj, id, selectedJobLinkId).then(
          (response) => {
            try {
              if (response.status === 200) {
                toast.success("Job link updated successfully");
                setModalLink(false);
                getJobLinksList();
              }
            } catch (err) {
              console.error("addJobLink " + JSON.stringify(err));
            }
          }
        );
      } else {
        JobService.addJobLink(jobLinkObj, id).then((response) => {
          try {
            if (response.status === 200) {
              toast.success("Job link created successfully");
              setModalLink(false);
              getJobLinksList();
            }
          } catch (err) {
            console.error("addJobLink " + JSON.stringify(err));
          }
        });
      }
    }
  };

  const openDeleteLinkConfirmation = (jobLink) => {
    setSelectedJobLinkName("");
    setSelectedJobLinkId(jobLink.id);

    setSelectedJobLinkId(jobLink.id);
    if (isNullOrEmpty(jobLink.name)) {
      setSelectedJobLinkName("");
    } else {
      setSelectedJobLinkName(jobLink.name);
    }
  };

  const deleteJobLink = () => {
    if (id !== 0) {
      JobService.deleteJobLink(id, selectedJobLinkId).then((response) => {
        try {
          if (response.status === 200) {
            toast.success("Job link deleted successfully");
            getJobLinksList();
          }
        } catch (err) {
          console.error("deleteJobLink " + JSON.stringify(err));
        }
      });
    }
  };

  const showJobLinksList = (jobLinks) => {
    return (
      <>
        {jobLinks.length > 0 &&
          jobLinks.map((jobLink) => {
            return (
              <tr>
                <td className="w-240">{jobLink.name}</td>
                <td className="w-240">
                  <a href={jobLink.link} target="_blank">
                    <h5 className="card-title text-dark">
                      <u>
                        {" "}
                        <strong>
                          {!isNullOrEmpty(jobLink.link) ? (
                            <>
                              <div
                                className="mb-0"
                                style={{ textOverflow: "clip" }}
                              >
                                {jobLink.link.length > 80
                                  ? jobLink.link.substring(0, 40) + "..."
                                  : jobLink.link}
                              </div>
                            </>
                          ) : (
                            <>&nbsp;&nbsp;</>
                          )}
                        </strong>
                      </u>
                    </h5>
                  </a>
                </td>

                <td className="w-240">
                  <p className="card-text " title={jobLink.description}>
                    {" "}
                    {!isNullOrEmpty(jobLink.description) ? (
                      <>
                        <p className="mb-0" style={{ textOverflow: "clip" }}>
                          {jobLink.description.length > 60
                            ? jobLink.description.substring(0, 60) + "..."
                            : jobLink.description}
                        </p>
                      </>
                    ) : (
                      <>&nbsp;&nbsp;</>
                    )}
                  </p>
                </td>
                <td>
                  <>
                    {jobStatus !== "CLOSED" && (
                      <>
                        <span className="mr-2 t-cursor-pointer">
                          <>
                            <i
                              className="simple-icon-note edit-copyiconsize arrow-icon-color"
                              title="Edit Link"
                              onClick={() => viewLinkDetails(jobLink)}
                            />
                          </>
                        </span>

                        <span>
                          <i
                            type="button"
                            data-toggle="modal"
                            data-target="#exampleModal1"
                            title="Delete Link"
                            disabled
                            className="simple-icon-trash edit-copyiconsize arrow-icon-color t-cursor-pointer"
                            onClick={() => openDeleteLinkConfirmation(jobLink)}
                          />
                        </span>
                      </>
                    )}
                  </>
                </td>
              </tr>
            );
          })}
      </>
    );
  };

  const viewLinkDetails = (jobLink) => {
    setSelectedJobLinkId(jobLink.id);

    if (!isNullOrEmpty(jobLink.name)) {
      setInputFieldLink((prevState) => ({
        ...prevState,
        name: jobLink.name,
      }));
    }

    if (!isNullOrEmpty(jobLink.link)) {
      setInputFieldLink((prevState) => ({
        ...prevState,
        link: jobLink.link,
      }));
    }

    if (!isNullOrEmpty(jobLink.description)) {
      setInputFieldLink((prevState) => ({
        ...prevState,
        description: jobLink.description,
      }));
    }
    setModalLink(true);
  };

  return (
    <>
      <div>
        <div className="skill-header"></div>

        <div>
          <Modal
            isOpen={modalRight}
            toggle={() => setModalRight(!modalRight)}
            wrapClassName="modal-right"
            className="file-model-width"
            disabled={window.localStorage.getItem("view") === "view"}
          >
            <ModalHeader>
              <div className="row">Upload Documents</div>
            </ModalHeader>
            <ModalBody>
              <Row>
                <Colxx xxs="12">
                  <Row className="mb-1">
                    <Colxx xxs="12">
                      <Form>
                        <FormGroup row>
                          <Label sm={4}>
                            Name*
                            {/* <span className="required-star"></span> */}
                          </Label>
                          <Colxx sm={12}>
                            <Input
                              className="t-rounded-lg"
                              type="name"
                              name="name"
                              onChange={inputsHandler}
                              value={inputField.name}
                              placeholder={"Name"}
                              onKeyPress={handleKeyPress}
                            />
                          </Colxx>
                        </FormGroup>

                        <FormGroup row>
                          <Label sm={4}>
                            File Type*
                            {/* <span className="required-star"></span> */}
                          </Label>
                          <Colxx sm={12}>
                            <Input
                              className="t-rounded-lg"
                              value={fileType}
                              type="select"
                              onChange={handleFileTypeSelectChange}
                              defaultValue={"DEFAULT"}
                            >
                              <option value="">Please Select</option>
                              {fileTypes.length > 0 &&
                                fileTypes.map(({ value, key }) => (
                                  <option value={key} key={key}>{value}</option>
                                ))}
                            </Input>
                          </Colxx>
                        </FormGroup>
                        <FormGroup row>
                          <Label sm={4}>Description:</Label>
                          <Colxx sm={12}>
                            <Input
                              className="t-rounded-lg"
                              rows="4"
                              id="description"
                              type="textarea"
                              maxLength="255"
                              name="description"
                              onChange={inputsHandler}
                              value={inputField.description}
                            />
                          </Colxx>
                        </FormGroup>

                        <FormGroup row>
                          <Colxx sm={12}>
                            <Input
                              type="file"
                              id="JobFiles"
                              className="form-control t-rounded-lg"
                              // accept=".jpg,.gif,.jpeg,.png"
                              // onChange={handleClick}
                              placeholder="Select file"
                              style={{ height: "6.1vh" }}
                            />
                            <Label>
                              Size limit: 32 MBytes per file / 32 MBytes total.
                            </Label>
                          </Colxx>
                        </FormGroup>
                      </Form>
                    </Colxx>
                  </Row>
                </Colxx>
              </Row>
            </ModalBody>
            <ModalFooter className="model-button">
              <Button
                test-id="uploadfile"
                color="primary"
                size="sm"
                outline
                onClick={uploadFile}
              >
                Save
              </Button>{" "}
              <Button
                color="primary"
                size="sm"
                className="ml-1"
                outline
                onClick={() => setModalRight(false)}
              >
                Cancel
              </Button>
            </ModalFooter>
          </Modal>
        </div>

        <Row className="mb-5">
          <Colxx xxs="">
            <Card className="mb-4">
              <CardHeader className="text-right">
                {jobStatus !== "CLOSED" && (
                  <div className="col-sm-12">
                    <div className="row t-cardheader-alignment">
                      <div>
                        {" "}
                        <b>Upload Document</b>
                      </div>
                      <div className="col-sm-6 end">
                        <Button
                          color="primary"
                          size="sm"
                          disabled={
                            window.localStorage.getItem("view") === "view"
                          }
                          outline
                          onClick={onAddSoftSkills}
                        >
                          Upload
                        </Button>
                      </div>
                    </div>
                  </div>
                )}
              </CardHeader>
              <CardBody>
                <div>
                  <Table className="table-responsive">
                    <thead>
                      <tr>
                        <th className="w-20">File Name</th>
                        <th className="w-40">File Type</th>
                        <th className="w-40">Description</th>
                        <th className="w-20">Actions</th>
                      </tr>
                    </thead>

                    <tbody>
                      {files.length > 0 ? (
                        files.map((file, index) => (
                          <tr key={index}>
                            <td className="w-240">
                              <a
                                className="text-dark"
                                href={file.fileKey}
                                // target="_blank"
                              >
                                <u>{file.name}</u>
                              </a>
                            </td>

                            <td className="w-240">{file.fileType.value}</td>

                            <td className="w-240">
                              <p className="card-text" title={file.description}>
                                {" "}
                                {!isNullOrEmpty(file.description) ? (
                                  <>
                                    <p
                                      className="mb-0"
                                      style={{ textOverflow: "clip" }}
                                    >
                                      {file.description.length > 40
                                        ? file.description.substring(0, 40) +
                                          "..."
                                        : file.description}
                                    </p>
                                  </>
                                ) : (
                                  <>&nbsp;&nbsp;</>
                                )}
                              </p>
                            </td>
                            <td>
                              <>
                                {/* <a
                                  href={file.fileKey}
                                  // target="_blank"
                                >
                                  <>
                                    <i
                                      className=" simple-icon-cloud-download download-icon  emp_icon"
                                      title="Download File"
                                      disabled={
                                        window.localStorage.getItem("view") ===
                                        "view"
                                      }
                                    />
                                  </>
                                </a> */}

                                <span
                                  disabled={
                                    window.localStorage.getItem("view") ===
                                    "view"
                                  }
                                >
                                  <>
                                    {window.localStorage.getItem("view") ===
                                    "view" ? (
                                      <>
                                        <i
                                          type="button"
                                          data-toggle="modalrock"
                                          data-target="#exampleModalrock"
                                          title="Delete File"
                                          disabled
                                          className="simple-icon-trash edit-copyiconsize arrow-icon-color mr-1  emp_icon"
                                          onClick={() =>
                                            handlefileupload(file.id, file.name)
                                          }
                                        />
                                      </>
                                    ) : (
                                      <>
                                        {jobStatus !== "CLOSED" && (
                                          <i
                                            type="button"
                                            data-toggle="modal"
                                            data-target="#exampleModal"
                                            title="Delete File"
                                            disabled
                                            className="simple-icon-trash edit-copyiconsize arrow-icon-color ml-1  emp_icon"
                                            onClick={() =>
                                              handlefileupload(
                                                file.id,
                                                file.name
                                              )
                                            }
                                          />
                                        )}
                                      </>
                                    )}
                                  </>
                                </span>
                              </>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <></>
                      )}
                    </tbody>
                  </Table>
                  {files.length === 0 && (
                    <h4
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <strong>No data found</strong>
                    </h4>
                  )}
                </div>
              </CardBody>
            </Card>
            <hr></hr>
            <Card className="mb-4 mt-2">
              <CardHeader className="text-right">
                <div className="col-sm-12">
                  <div className="row t-cardheader-alignment">
                    <div>
                      <strong>Links</strong>
                    </div>
                    <div className="col-sm-6">
                      {jobStatus !== "CLOSED" && (
                        <Button
                          color="primary"
                          size="sm"
                          outline
                          onClick={AddLinks}
                        >
                          Add Link
                        </Button>
                      )}
                    </div>
                  </div>
                </div>
              </CardHeader>
              <CardBody>
                <div>
                  <div className="tableContainer">
                    <div className="tablewrapper">
                      <Table className=" hms_table  jobRequisition_table table-responsive">
                        <thead>
                          <tr>
                            <th className="w-20"> Name</th>
                            <th className="w-40">Link</th>
                            <th className="w-40">Description</th>
                            <th className="w-20">Actions</th>
                          </tr>
                        </thead>

                        <tbody>{showJobLinksList(jobLinks)}</tbody>
                      </Table>
                    </div>
                  </div>
                  {jobLinks.length === 0 && (
                    <h4
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <strong>No data found</strong>
                    </h4>
                  )}
                </div>
              </CardBody>
            </Card>

            <Row>
              <div>
                <Colxx>
                  <FormGroup>
                    <Button
                      className="mt-2"
                      color="primary"
                      size="sm"
                      outline
                      onClick={handlePreviousButton}
                    >
                      <MdOutlineArrowBackIosNew />
                    </Button>
                    <Button
                      disabled={id !== "" ? false : true}
                      className="mt-2 ml-2"
                      color="primary"
                      size="sm"
                      outline
                      onClick={handleNextButton}
                    >
                      Next
                    </Button>
                  </FormGroup>
                </Colxx>
              </div>
            </Row>
          </Colxx>
          <Separator className="mt-5 mb-5"></Separator>
        </Row>
      </div>

      <div
        className="modal fade mt-5"
        id="exampleModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-body">
              <h3>
                Do you want to delete{" "}
                <strong>{" " + fileuploadname + " "}</strong>
                file?
              </h3>
            </div>

            <div className="modal-footer p-3">
              <Button
                type="button"
                color="primary"
                size="sm"
                outline
                data-dismiss="modal"
              >
                Close
              </Button>
              <Button
                type="button"
                disabled={window.localStorage.getItem("view") === "view"}
                color="primary"
                size="sm"
                outline
                data-dismiss="modal"
                onClick={() => {
                  deleteDocument();
                }}
              >
                Delete
              </Button>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade mt-5"
        id="exampleModal1"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-body">
              <h3>
                Do you want to delete{" "}
                <strong>{" " + selectedJobLinkName + " "}</strong>
                link?
              </h3>
            </div>

            <div className="modal-footer p-3">
              <Button
                type="button"
                color="primary"
                size="sm"
                outline
                data-dismiss="modal"
              >
                Close
              </Button>
              <Button
                type="button"
                disabled={window.localStorage.getItem("view") === "view"}
                color="primary"
                size="sm"
                outline
                data-dismiss="modal"
                onClick={() => {
                  deleteJobLink();
                }}
              >
                Delete
              </Button>
            </div>
          </div>
        </div>
      </div>

      <Modal
        isOpen={modalLink}
        toggle={() => setModalLink(!modalLink)}
        wrapClassName="modal-right"
        className="file-model-width"
      >
        <ModalHeader>
          <div className="row">
            {isNullOrEmpty(selectedJobLinkId) ? (
              <>
                <strong>Add Link</strong>
              </>
            ) : (
              <>
                <strong>Update Link</strong>
              </>
            )}
          </div>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Colxx xxs="12">
              <Row className="mb-1">
                <Colxx xxs="12">
                  <Form>
                    <FormGroup row>
                      <Label sm={4}>
                        Name*
                        {/* <span className="required-star"></span> */}
                      </Label>
                      <Colxx sm={12}>
                        <Input
                          className="t-rounded-lg"
                          type="name"
                          name="name"
                          onChange={inputsHandlerLink}
                          value={inputFieldLink.name}
                        />
                      </Colxx>
                    </FormGroup>

                    <FormGroup row>
                      <Label sm={4}>
                        Link*
                        {/* <span className="required-star"></span> */}
                      </Label>
                      <Colxx sm={12}>
                        <Input
                          className="t-rounded-lg"
                          type="link"
                          name="link"
                          placeholder={"Link"}
                          onChange={inputsHandlerLink}
                          value={inputFieldLink.link}
                        />
                      </Colxx>
                    </FormGroup>
                    <FormGroup row>
                      <Label sm={4}>Description:</Label>
                      <Colxx sm={12}>
                        <Input
                          className="t-rounded-lg"
                          rows="4"
                          id="description"
                          type="textarea"
                          maxLength="255"
                          name="description"
                          onChange={inputsHandlerLink}
                          value={inputFieldLink.description}
                        />
                      </Colxx>
                    </FormGroup>
                  </Form>
                </Colxx>
              </Row>
            </Colxx>
          </Row>
        </ModalBody>
        <ModalFooter className="model-button">
          <Button
            test-id="uploadfile"
            color="primary"
            size="sm"
            outline
            onClick={addJobLink}
          >
            {isNullOrEmpty(selectedJobLinkId) ? <>Save</> : <>Update</>}
          </Button>{" "}
          <Button
            color="primary"
            size="sm"
            className="ml-1"
            outline
            onClick={() => setModalLink(false)}
          >
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default FileUpload;
